import {
    FETCH_SOLAR_INTENSITY,
    FETCH_SOLAR_INTENSITY_SUCCESS,
    FETCH_SOLAR_INTENSITY_FAIL,
    SET_SOLAR_DATE,
    FETCH_SOLAR_INTENSITY_FETCHING
} from 'actions/solarIntensityActions.js';

const INITIAL_STATE = {
    solarDailyDataDTOs: [],
    solarGainDailyDetailDTOList: [],
    solarCharge: [],
    solarIntensityFetching: false
};

const setSolarSuccess = (state, action) => {
    return {
        ...state,
        ...action,
        [action.deviceId]: {
            ...state[action.deviceId]
        },
        solarIntensityFetching: false,
        solarIntensityFetchingSuccess: true
    };
};

const fetchSolarIntensitySuccess = (state, action) => {
    return {
        ...state,
        [action.deviceId]: {
            [action.calendarDate]: {
                ...action.solarTimeLine,
                ...action.activitySummary
            },
            [action.calendarRange]: action.solarCharge,
            [action.previousCalendarRange]: action.previousSolarCharge,
            ...state[action.deviceId]
        },
        solarIntensityFetching: false,
        solarIntensityFetchingSuccess: true
    };
};

const fetchSolarIntensityFail = (state, action) => {
    return {
        ...state,
        [action.deviceId]: {
            [action.calendarDate]: {
                solarDailyDataDTOs: []
            }
        },
        solarIntensityFetching: false,
        solarIntensityFetchingSuccess: false
    };
};

const fetchSolarIntensityFetching = (state, action) => {
    return {
        ...state,
        [action.deviceId]: {
            [action.calendarDate]: {
                ...action.solarTimeLine,
                ...action.activitySummary
            },
            [action.calendarRange]: action.solarCharge,
            [action.previousCalendarRange]: action.previousSolarCharge,
            ...state[action.deviceId]
        },
        solarIntensityFetching: true,
        solarIntensityFetchingSuccess: false
    };
};

const handlers = {
    [SET_SOLAR_DATE]: setSolarSuccess,
    [FETCH_SOLAR_INTENSITY_SUCCESS]: fetchSolarIntensitySuccess,
    [FETCH_SOLAR_INTENSITY_FAIL]: fetchSolarIntensityFail,
    [FETCH_SOLAR_INTENSITY_FETCHING]: fetchSolarIntensityFetching
};

export default function solarIntensity(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function setSolarDate(
    calendarDate,
    deviceId,
    calendarRange = calendarDate + '-' + calendarDate,
    previousCalendarRange
) {
    return {
        type: SET_SOLAR_DATE,
        calendarDate: calendarDate,
        calendarRange: calendarRange,
        previousCalendarRange: previousCalendarRange,
        deviceId: deviceId
    };
}

export function fetchSolarIntensity(payload, evictCache) {
    return {
        type: FETCH_SOLAR_INTENSITY,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// Getters
export const getSolarIntensity = (state, today, deviceId) => {
    if (state.solarIntensity[deviceId]) {
        return state.solarIntensity[deviceId][today] && state.solarIntensity[deviceId][today].solarDailyDataDTOs;
    } else {
        return state.solarIntensity;
    }
};

export const getSolarCharge = (state, calendarRange, deviceId) => {
    if (state.solarIntensity[deviceId]) {
        return state.solarIntensity[deviceId][calendarRange] && state.solarIntensity[deviceId][calendarRange];
    } else {
        return state.solarIntensity;
    }
};

export const getPreviousRangeSolarCharge = (state, previousCalendarRange, deviceId) => {
    if (state.solarIntensity[deviceId]) {
        return (
            state.solarIntensity[deviceId][previousCalendarRange] &&
            state.solarIntensity[deviceId][previousCalendarRange]
        );
    } else {
        return state.solarIntensity;
    }
};

export const getSolarActivities = (state, today, deviceId) => {
    if (state.solarIntensity[deviceId]) {
        return state.solarIntensity[deviceId][today] && state.solarIntensity[deviceId][today].activitiesList;
    } else {
        return state.solarIntensity;
    }
};

export const isSolarIntensityFetching = (state) => {
    return state.solarIntensity.solarIntensityFetching;
};

export const isSolarIntensityFetchSuccessful = (state) => {
    return state.solarIntensity.solarIntensityFetchingSuccess;
};
